export default function (other) {
  other = other || {};
  return {
    range: {
      from: other.range?.from || null,
      until: other.range?.until || null,
    },
    orgIds: other.orgIds || [],
    buIds: other.buIds || [],
    buTypes: other.buTypes || [],
    representativeUserIds: other.representativeUserIds || [],
  };
}
